module.exports = __webpack_public_path__ + "static/media/test.117b0665.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test.pdf
// module id = 1264
// module chunks = 2